export const SITE = {
  name: "BLOOMORA",
  hindi: "ब्लूमोरा",
  tagline: "The Sweet Spot & Savouries – Family Restaurant",
  phone: "8709317269",
  phoneHref: "tel:+918709317269",
  whatsapp: "https://wa.me/918709317269?text=Namaste%20Bloomora!%20I%27d%20like%20to%20know%20more%20about%20today%27s%20menu.",
  mapsLink: "https://maps.app.goo.gl/chqoTSHsnj7VJRGx9",
  mapsEmbed:
    "https://www.google.com/maps?q=Tin+Bazar+Road,+Bhagalpur+Road,+Dumka,+Jharkhand+814101&output=embed",
  address:
    "Ward No: 13, Bhagalpur Road, Tin Bazar Road, near Dharmsthan Mandir, Dumka, Jharkhand 814101",
  footerLine: "Bloomora – Where every meal blooms",
};

export const GALLERY_IMAGES = [
  { src: "/images/interior-04.jpg", alt: "Family table under the bougainvillea canopy and neon Bloomora glow" },
  { src: "/images/interior-00.jpg", alt: "Blush corridor with gold-lit mirrors and the floral ceiling grid" },
  { src: "/images/interior-01.jpg", alt: "Pink dining hall with custom lighting arches" },
  { src: "/images/interior-02.jpg", alt: "Aesthetic seating beneath hanging blossoms" },
  { src: "/images/interior-03.jpg", alt: "Rose-toned booth corner with soft lamps" },
  { src: "/images/interior-05.jpg", alt: "Blossom wall and marble table setting" },
  { src: "/images/interior-06.jpg", alt: "Warm lantern light against pink panels" },
  { src: "/images/interior-07.jpg", alt: "Evening glow across the Bloomora dining floor" },
  { src: "/images/gallery-10.jpg", alt: "Neon BLOOMORA sign beneath cascading bougainvillea" },
  { src: "/images/gallery-03.jpg", alt: "Pink dining hall with floral arches and hanging lanterns" },
  { src: "/images/gallery-05.jpg", alt: "Table setting with candles and roses" },
];

export const MENU = [
  {
    id: "nibbles",
    name: "NIBBLES",
    note: "Little joys to begin with — crisp, golden, impossible to share.",
    items: [
      { name: "French Fries", price: 199, desc: "Golden batons, twice-cris whispered with house salt." },
      { name: "Peri Peri Fries", price: 219, desc: "Fries tossed in a fiery peri-peri blush." },
      { name: "Cheese Loaded Fries", price: 249, desc: "A molten cheddar waterfall over crisp fries." },
      { name: "Nachos", price: 179, desc: "Crackling corn chips with salsa and warm cheese." },
      { name: "Veg Loaded Nachos", price: 229, desc: "Nachos heaped with garden crunch, beans and cheese." },
      { name: "Crispy Potato Wedges", price: 189, desc: "Rustic wedges, crackled edges, soft hearts." },
    ],
  },
  {
    id: "initiator",
    name: "INITIATOR",
    note: "Starters that open the evening like the first blossom of spring.",
    items: [
      { name: "Corn Salt N Pepper", price: 249, desc: "Sweet corn kernels crackled with pepper and spring onion." },
      { name: "Mushroom Manchurian", price: 299, desc: "Plump mushrooms glazed in a soy-garlic embrace." },
      { name: "Stuffed Mushrooms", price: 299, desc: "Button mushrooms hiding a herbed cheese secret." },
      { name: "Crispy Chilli Babycorn", price: 279, desc: "Babycorn in a crackling coat, kissed with chilli." },
      { name: "Thai Style Chilli Basil Cottage Cheese", price: 375, desc: "Paneer tossed with holy basil, Thai chilli and lime." },
      { name: "Tangra Style Paneer", price: 315, desc: "Kolkata-street style — smoky, garlicky, unforgettable." },
      { name: "Crispy Honey Chilli Potato", price: 225, desc: "Sticky-sweet honey glaze over crackled potato fingers." },
    ],
  },
  {
    id: "burger",
    name: "BURGER",
    note: "Soft toasted buns, generous hearts.",
    items: [
      { name: "Classic Veggie Burger", price: 149, desc: "A crisp garden patty, house mayo, cool lettuce." },
      { name: "Cheese Burst Burger", price: 169, desc: "A molten cheese core waiting under the first bite." },
      { name: "Mexican Fiesta Burger", price: 169, desc: "Salsa, jalapeño and a little dance of spice." },
      { name: "Paneer Crunch Burger", price: 179, desc: "Crumb-fried paneer with minty slaw." },
      { name: "Bloomora Signature Burger", price: 179, desc: "Our secret pink sauce — the house favourite." },
    ],
  },
  {
    id: "indian",
    name: "INDIAN",
    note: "Slow-simmered gravies from our family kitchen.",
    items: [
      { name: "Paneer Butter Masala", price: 289, desc: "Succulent paneer pieces simmered in a silky, nutty gravy." },
      { name: "Shahi Paneer", price: 299, desc: "A royal cashew-tomato gravy, gently sweet." },
      { name: "Kadhai Paneer", price: 299, desc: "Charred capsicum and crushed coriander, wok-tossed." },
      { name: "Paneer Lababdar", price: 309, desc: "Rich, rustic and indulgent — a labour of love." },
      { name: "Palak Paneer", price: 279, desc: "Emerald spinach folded around soft paneer." },
      { name: "Malai Kofta", price: 299, desc: "Velvet dumplings floating in cashew cream." },
      { name: "Mushroom Masala", price: 289, desc: "Earthy mushrooms in a home-style onion gravy." },
      { name: "Veg Kolhapuri", price: 259, desc: "A bold Kolhapur fire for brave hearts." },
      { name: "Mix Veg", price: 239, desc: "The day's freshest vegetables, simply loved." },
      { name: "Dal Makhani", price: 249, desc: "Black lentils simmered overnight with butter." },
      { name: "Dal Tadka", price: 219, desc: "Yellow dal finished with a ghee-tempered flourish." },
      { name: "Chana Masala", price: 229, desc: "Chickpeas in a tangy, soulful masala." },
    ],
  },
  {
    id: "rice-noodles",
    name: "RICE & NOODLES",
    note: "Wok-kissed and smoky, straight from the flame.",
    items: [
      { name: "Veg Fried Rice", price: 199, desc: "Smoky wok-tossed rice with garden vegetables." },
      { name: "Schezwan Fried Rice", price: 219, desc: "A fiery red wok breath over fragrant rice." },
      { name: "Paneer Fried Rice", price: 239, desc: "Golden paneer cubes folded through smoky rice." },
      { name: "Triple Schezwan Rice", price: 249, desc: "Rice, noodles and gravy — a triple love story." },
      { name: "Veg Hakka Noodles", price: 199, desc: "Silken noodles tossed over a dancing flame." },
      { name: "Schezwan Noodles", price: 219, desc: "Noodles with a slow-building schezwan warmth." },
      { name: "Singapore Noodles", price: 229, desc: "Curry-kissed vermicelli, bright and light." },
      { name: "Veg Chowmein", price: 179, desc: "The street-corner classic, done our way." },
    ],
  },
  {
    id: "biryani",
    name: "BIRYANI",
    note: "Sealed on dum, opened at your table.",
    items: [
      { name: "Veg Biryani", price: 229, desc: "Fragrant basmati layered with garden vegetables." },
      { name: "Hyderabadi Veg Dum Biryani", price: 259, desc: "Slow-steamed under a dough seal, saffron-kissed." },
      { name: "Paneer Biryani", price: 269, desc: "Marinated paneer nestled in aromatic rice." },
      { name: "Mushroom Biryani", price: 279, desc: "Earthy mushrooms in layers of spice and saffron." },
      { name: "Bloomora Special Biryani", price: 319, desc: "The chef's guarded recipe — our blooming pride." },
    ],
  },
  {
    id: "breads",
    name: "BREADS",
    note: "From the tandoor's warm heart.",
    items: [
      { name: "Tandoori Roti", price: 35, desc: "Whole-wheat, puffed over live coals." },
      { name: "Butter Roti", price: 45, desc: "Tandoori roti brushed with melting butter." },
      { name: "Plain Naan", price: 60, desc: "Pillow-soft leavened bread, tandoor-kissed." },
      { name: "Butter Naan", price: 70, desc: "Naan glossed with a golden butter sheen." },
      { name: "Garlic Naan", price: 85, desc: "Flecked with garlic and fresh coriander." },
      { name: "Cheese Naan", price: 110, desc: "A molten cheese heart inside soft naan." },
      { name: "Laccha Paratha", price: 65, desc: "Sixteen flaky layers, crisp at the edges." },
      { name: "Missi Roti", price: 55, desc: "Besan and spice, rustic and wholesome." },
      { name: "Stuffed Kulcha", price: 95, desc: "Amritsari-style, stuffed with spiced potato." },
    ],
  },
  {
    id: "momo",
    name: "MOMO",
    note: "Little steamed clouds from the hills.",
    items: [
      { name: "Veg Steam Momo", price: 129, desc: "Delicate pleats, garden filling, fiery chutney." },
      { name: "Veg Fried Momo", price: 149, desc: "Golden-crisp outside, tender within." },
      { name: "Paneer Momo", price: 169, desc: "Soft paneer hearts in thin steamed skins." },
      { name: "Cheese Corn Momo", price: 179, desc: "Molten cheese and sweet corn surprise." },
      { name: "Chilli Momo", price: 179, desc: "Wok-tossed with chilli, garlic and soy." },
      { name: "Tandoori Momo", price: 189, desc: "Charred in the tandoor, smoky and bold." },
      { name: "Kurkure Momo", price: 199, desc: "Crumb-crackled momos, pure crunch joy." },
    ],
  },
  {
    id: "pizza",
    name: "PIZZA",
    note: "Hand-stretched, stone-baked, generously topped.",
    items: [
      { name: "Margherita", price: 199, desc: "Tomato, basil and molten mozzarella — pure classic." },
      { name: "Corn & Cheese", price: 229, desc: "Golden corn over a bubbling cheese bed." },
      { name: "Veggie Supreme", price: 249, desc: "A harvest of peppers, onion and mushroom." },
      { name: "Farm House", price: 269, desc: "Garden-fresh toppings edge to edge." },
      { name: "Paneer Tikka Pizza", price: 279, desc: "Smoky paneer tikka over makhani sauce." },
      { name: "Tandoori Paneer Pizza", price: 289, desc: "Tandoori char meets Italian crust." },
      { name: "Bloomora Special Pizza", price: 299, desc: "Everything we love, on one golden disc." },
    ],
  },
  {
    id: "bao",
    name: "BAO",
    note: "Pillowy steamed buns, folded with care.",
    items: [
      { name: "Veg Steam Bao", price: 159, desc: "Cloud-soft buns hugging glazed vegetables." },
      { name: "Schezwan Bao", price: 169, desc: "A fiery schezwan heart in a pillowy fold." },
      { name: "Cheese Corn Bao", price: 179, desc: "Sweet corn and cheese in a warm cloud." },
      { name: "Paneer Chilli Bao", price: 189, desc: "Chilli paneer tucked into soft steamed dough." },
      { name: "Crispy Fried Bao", price: 189, desc: "Golden-fried outside, molten inside." },
    ],
  },
  {
    id: "south-indian",
    name: "SOUTH INDIAN",
    note: "Crisp dosas and cloud idlis, with love from the south.",
    items: [
      { name: "Idli Sambar", price: 99, desc: "Steamed rice clouds with warm sambar." },
      { name: "Medu Vada", price: 109, desc: "Crisp golden doughnuts of the south." },
      { name: "Plain Dosa", price: 119, desc: "Paper-crisp, ghee-kissed, timeless." },
      { name: "Masala Dosa", price: 149, desc: "Spiced potato folded in a golden crisp." },
      { name: "Uttapam", price: 139, desc: "Thick, soft, jewelled with onion and tomato." },
      { name: "Mysore Masala Dosa", price: 169, desc: "A fiery red chutney under the masala." },
      { name: "Cheese Dosa", price: 179, desc: "Molten cheese over a crisp golden crepe." },
      { name: "Paneer Dosa", price: 189, desc: "Spiced paneer bhurji in a crisp embrace." },
    ],
  },
  {
    id: "dessert",
    name: "DESSERT",
    note: "Every meal should end in bloom.",
    items: [
      { name: "Gulab Jamun", price: 99, desc: "Warm syrup-soaked pillows of joy." },
      { name: "Rasgulla", price: 89, desc: "Featherlight chenna in rose syrup." },
      { name: "Moong Dal Halwa", price: 129, desc: "Slow-stirred golden warmth with ghee." },
      { name: "Kulfi Falooda", price: 139, desc: "Kulfi over vermicelli and rose petals." },
      { name: "Ice Cream Sundae", price: 149, desc: "Three scoops, nuts and a cherry bloom." },
      { name: "Brownie with Ice Cream", price: 179, desc: "Warm fudge brownie meets cold vanilla." },
      { name: "Sizzling Brownie", price: 199, desc: "Arrives smoking on a hot iron plate." },
    ],
  },
];
